<ng-container
  *ngIf="list|async as listArray">
  <section [class.disabled]="!displayActionButtons && edit"
         [class.not-editable]="!edit"
         [class.priority-available]="priorityAvailable"
         [class.spread-priority-items]="priorityAvailable && !showPractitionerLayout"
         [class.collapsed-section]="collapsed"
         [ngClass]="automationClass"
           *ngIf="selectedLength >= minSelection"
         class="priority-element-container">
  <div class="show-while-collapsed title-wrapper fa fa-chavron-down"
       *ngIf="!edit && showPractitionerLayout"
       (click)="collapsed = !collapsed">
    <div class="review-title  {{'Auto_Title_Reviewer_'+countText}}">
      {{countText}}
      <ng-container *ngIf="!collapsed">reviewer's ranking</ng-container>
    </div>
  </div>

  <gen-selection-list class="selection-list"
                      [ngClass]="{
                        'spread-selection-list': priorityAvailable && !showPractitionerLayout,
                        'priority-available': priorityAvailable && edit
                      }"
                      *ngIf="fields"
                      [id]="revisionId"
                      [disabled]="!edit"
                      [edit]="edit"
                      [listModel]="listArray"
                      [listName]="edit?'destination':'viewer '+count"
                      [fields]="fields"
                      [prioritizeAvailable]="priorityAvailable"
                      [counter]="priorityAvailable"
                      (deleteActionEmit)="removeTherapy($event)"
                      (listOrderChangedEmit)="updateListOrder($event)"
                      [listType]="therapyListType()"
  >
    <gen-therapies-add-new class="item list-item-wrapper manual"
                           [ngClass]="{'active':inprogress}"
                           [allowTherapyFreeText]="allowTherapyFreeText"
                           (addTherapyEmit)="addNewTherapy($event)"
                           (addTrialEmit)="addNewTherapy($event)"
                           [targetMaxLength]="targetMaxLength"
                           [EnableAddingTrials]="EnableAddingTrials"
                           (inprogressEmit)="inprogress = $event"

                           add-button>
    </gen-therapies-add-new>
  </gen-selection-list>
  <section class="text-section"
    [ngClass]="{
      'spread-rationale-section': priorityAvailable && !showPractitionerLayout
    }">
  <textarea pInputTextarea *ngIf="edit && textEditable"
            rows="5" cols="30"
            [ngModel]="rationale"
            (ngModelChange)="updateRationale($event)"
            [ngModelOptions]="{updateOn:'blur'}"
            placeholder="Enter rationale for prioritization"
            autoResize
            name="rationale-input"
            id="rationale"
            class="textual-content"></textarea>
    <div class="show-while-collapsed textual-content viewer" *ngIf="(!edit && textEditable) || !textEditable ">
      <div class="profile-data-wrapper" *ngIf="!edit && showPractitionerLayout">
        <gen-user-profile class="profile-data-pic" [id]="practitionerID" [date]="setDate|date:'dd MMM y hh:mm'  "
                          [layout]="'PIC_ONLY'"
                          [userType]="userType"></gen-user-profile>
      </div>
      <div class="text-wrapper">
        <gen-user-profile priority-element-containeclass="profile-data-name"
                          *ngIf="!edit && showPractitionerLayout"
                          [id]="practitionerID" [date]="setDate|date:'dd MMM y HH:mm'  "
                          [layout]="'NAME_AND_DATE'"
                          [userType]="userType"></gen-user-profile>
        <span class="content">{{rationale}}</span>
      </div>
    </div>
  </section>
</section>
</ng-container>
